<template>
  <el-form :model="taskForm" :rules="taskRules" ref="taskFormRef" label-width="80px">
    <el-form-item label="任务标题" prop="title">
      <el-input v-model="taskForm.title"></el-input>
    </el-form-item>
    <el-form-item label="任务描述" prop="description">
      <el-input type="textarea" v-model="taskForm.description"></el-input>
    </el-form-item>
    <el-form-item label="任务部分" prop="part">
      <el-select v-model="taskForm.part" placeholder="请选择任务部分">
        <el-option label="Day 1" value="Day1"></el-option>
        <el-option label="Day 2" value="Day2"></el-option>
        <el-option label="Day 3" value="Day3"></el-option>
        <el-option label="Day 4" value="Day4"></el-option>
        <el-option label="Day 5" value="Day5"></el-option>
      </el-select>
    </el-form-item>
     <el-form-item label="任务标签" prop="labels">
      <el-input v-model="taskForm.labels" placeholder="多个标签用逗号分隔"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm">创建任务</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { reactive, ref } from 'vue';
import taskApi from '../api/task';
import { ElMessage } from 'element-plus';

export default {
  emits: ['close'],
  setup(props, { emit }) {
    const taskFormRef = ref(null);
    const taskForm = reactive({
      title: '',
      description: '',
      part: '',
      labels: '',
    });

    const taskRules = reactive({
      title: [
        { required: true, message: '请输入任务标题', trigger: 'blur' },
        { max: 255, message: '任务标题不能超过255个字符', trigger: 'blur' },
      ],
      part: [
        { required: true, message: '请选择任务部分', trigger: 'change' },
      ],
    });

    const submitForm = () => {
      taskFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            await taskApi.createTask(taskForm);
            ElMessage.success('任务创建成功');
            emit('close'); // 关闭弹窗并通知父组件刷新列表
          } catch (error) {
            ElMessage.error('任务创建失败: ' + error.message);
          }
        } else {
          return false;
        }
      });
    };

    return {
      taskFormRef,
      taskForm,
      taskRules,
      submitForm,
    };
  },
};
</script>

<style scoped>
/* 样式可根据需要调整 */
</style> 